import { getJasBoardVerificationHistoryStorage, JasBoardsClient, } from '../../../../backend/features/jas-boards/shared';
import { jasBoardEntityName } from '../entities/defineJasBoardClassifier';
import { hasDurationPassed } from './hasDurationPassed';
const inactiveStatuses = ['retired', 'deprecated'];
export const updateJasBoardsVerificationHistory = ({ context, skipValidation, jasBoardFilter, }) => {
    var _a;
    const jasBoardStorage = context.storage(jasBoardEntityName);
    const jasBoardVerificationHistoryStorage = getJasBoardVerificationHistoryStorage(context);
    const jasBoards = jasBoardStorage.list({
        filter: jasBoardFilter,
    });
    const client = new JasBoardsClient(Object.assign(Object.assign({}, context), { jasBaseURL: context.screening.baseUrl, awsConfig: {
            awsAccessKey: context.appConfig.platformJasAccessKey,
            awsRegion: context.appConfig.platformJasRegion,
            awsSecretKey: context.appConfig.platformJasSecretAccessKey,
        } }));
    const now = new Date();
    for (const jasBoard of jasBoards.rows) {
        const jasBoardId = jasBoard.id;
        const previousJasBoardVerificationHistoryList = jasBoardVerificationHistoryStorage.list({
            filter: [
                {
                    column: 'jasBoardId',
                    op: '=',
                    value: jasBoardId,
                },
            ],
            orderBy: [
                {
                    column: 'lastCheckedAt',
                    desc: true,
                },
            ],
            limit: 1,
        });
        const previousJasBoardVerificationHistory = (_a = previousJasBoardVerificationHistoryList.rows.at(0)) === null || _a === void 0 ? void 0 : _a.columns;
        if (skipValidation === null || skipValidation === void 0 ? void 0 : skipValidation(jasBoard.columns, previousJasBoardVerificationHistory)) {
            continue;
        }
        if (inactiveStatuses.includes(jasBoard.columns.status)) {
            jasBoardVerificationHistoryStorage.post({
                action: 'create',
                data: {
                    lastCheckedAt: now.getTime(),
                    lastSuccessAt: previousJasBoardVerificationHistory === null || previousJasBoardVerificationHistory === void 0 ? void 0 : previousJasBoardVerificationHistory.lastSuccessAt,
                    lastUpdatedAt: previousJasBoardVerificationHistory === null || previousJasBoardVerificationHistory === void 0 ? void 0 : previousJasBoardVerificationHistory.lastUpdatedAt,
                    calculateAge: previousJasBoardVerificationHistory === null || previousJasBoardVerificationHistory === void 0 ? void 0 : previousJasBoardVerificationHistory.calculateAge,
                    name: jasBoard.columns.name,
                    status: 'inactive',
                    jasBoardId,
                },
            });
            continue;
        }
        const board = client.getBoard({ boardName: jasBoard.columns.name });
        switch (board.status) {
            case 'FAILED':
                jasBoardVerificationHistoryStorage.post({
                    action: 'create',
                    data: {
                        lastCheckedAt: now.getTime(),
                        lastSuccessAt: previousJasBoardVerificationHistory === null || previousJasBoardVerificationHistory === void 0 ? void 0 : previousJasBoardVerificationHistory.lastSuccessAt,
                        lastUpdatedAt: previousJasBoardVerificationHistory === null || previousJasBoardVerificationHistory === void 0 ? void 0 : previousJasBoardVerificationHistory.lastUpdatedAt,
                        name: jasBoard.columns.name,
                        status: 'failed',
                        jasBoardId,
                    },
                });
                break;
            case 'OK':
                if (jasBoard.columns.outOfDateAfter &&
                    board.updatedTime &&
                    hasDurationPassed(new Date(board.updatedTime), now, jasBoard.columns.outOfDateAfter * 24 * 60)) {
                    jasBoardVerificationHistoryStorage.post({
                        action: 'create',
                        data: {
                            status: 'outOfDate',
                            lastCheckedAt: now.getTime(),
                            lastSuccessAt: previousJasBoardVerificationHistory === null || previousJasBoardVerificationHistory === void 0 ? void 0 : previousJasBoardVerificationHistory.lastSuccessAt,
                            lastUpdatedAt: board.updatedTime,
                            calculateAge: board.calculateAge,
                            name: jasBoard.columns.name,
                            jasBoardId,
                        },
                    });
                    break;
                }
                jasBoardVerificationHistoryStorage.post({
                    action: 'create',
                    data: {
                        status: 'active',
                        lastCheckedAt: now.getTime(),
                        lastSuccessAt: now.getTime(),
                        calculateAge: board.calculateAge,
                        lastUpdatedAt: board.updatedTime,
                        name: jasBoard.columns.name,
                        jasBoardId,
                    },
                });
                break;
            default:
                break;
        }
    }
    return { success: true };
};
